import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import parse, { attributesToProps } from 'html-react-parser';
import sanitize from 'sanitize-html';
import { patchImageUrl } from '@culture/common-helpers/cultureUtils';

import { ImageFormatContext } from 'contexts/ImageFormatContext';
import LazyLoadImage from 'components/LazyLoad/Image';

const StyledContentHtml = ({ html }) => {
	const imageFormat = useContext(ImageFormatContext);

	return parse(sanitize(html), {
		replace(domNode) {
			const { type, name, attribs } = domNode;

			if (type === 'tag' && name === 'img' && attribs.src) {
				const imageSrc = patchImageUrl(attribs.src, { format: imageFormat });
				const props = attributesToProps({ ...attribs, src: imageSrc });

				return (
					<LazyLoadImage imageSrc={imageSrc}>
						<img alt="" {...props} />
					</LazyLoadImage>
				);
			}

			return null;
		}
	});
};

StyledContentHtml.propTypes = {
	html: PropTypes.string.isRequired,
	firstParagraph: PropTypes.bool
};

StyledContentHtml.defaultProps = {
	firstParagraph: false
};

export default StyledContentHtml;
